import {BaseApiRequestParams} from "../../infrastructure/models/params/base-api-request-params";

export class AthleteEventsChartRequestParams extends BaseApiRequestParams {

  constructor(athletesIds: Array<Number>) {
    super('athletes/chartEvents');

    this.athletesIds = athletesIds;
  }

  get athletesParam() {
    return this.athletesIds?.length > 0  ? `&athletes=${this.athletesIds.toString()}` : '';
  }

  toString(): String {
    return super.toString() + this.athletesParam;
  }

  equals(model: AthleteEventsChartRequestParams): * {
    let equals = super.equals(model);

    equals &= this.athletesParam === model.athletesParam;

    return equals;
  }
}